import { TermProgramInfoModel } from '../../../term_courses/models/term_program_info_model';
import { CourseDetailsQuery } from '../../queries/course_details_query';
import { CourseDetailsModel } from '../../models/course_details_model';
import { ScheduledSectionsQuery } from '../../../course_scheduler/queries/scheduled_sections_query';
import { ICourseDetails, ISectionType, ICourseRequisite } from '../../../../interfaces/scheduler_interfaces';
import { ICommand, IQueryMediator } from 'core-ts-types';
import * as _4 from 'lodash4';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { RegistrationAlertsServant } from '../../../course_scheduler/servants/registration_alerts_servant';
import { CourseDetailsCrossCoreqQuery } from '../../queries/course_details_cross_coreq_query';

class CourseDetail {
  private courseDetails: ICourseDetails;
  private termName: string;
  private courseCoreqStatus: string;
  private termId: number;
  private hasOptionalSections: boolean;
  private isOpened: boolean = true;
  private openBound: () => void;
  private closeBound: () => void;
  constructor(
    private ngCourseDetailsQuery: CourseDetailsQuery,
    private ngScheduledSectionsQuery: ScheduledSectionsQuery,
    private $state: any,
    private saveCoReqCourseToTermCommand: ICommand,
    private getTermCoursesCommand: ICommand,
    private clearCrossCourseLinkedSectionsCommand: ICommand,
    private ngCourseDetailsModel: CourseDetailsModel,
    private QueryMediator: IQueryMediator,
    private ngTermProgramInfoModel: TermProgramInfoModel,
    private ngCourseDetailsCrossCoreqQuery: CourseDetailsCrossCoreqQuery,
    private ngRegistrationAlertsServant: RegistrationAlertsServant,
    private ngComponentCommunicatorService: CommunicatorService
  ) {}
  initialize() {
    if (_4.isUndefined(this.ngCourseDetailsQuery.result) || !this.ngCourseDetailsQuery.result) {
      return;
    }
    this.termId = _4.get(this.ngTermProgramInfoModel.read(), 'term.id');
    this.termName = _4.get(this.ngTermProgramInfoModel.read(), 'term.name');
    this.hasOptionalSections = _4.some(
      this.ngCourseDetailsQuery.result.course._section_types,
      (sType: ISectionType) => !sType.is_required
    );
  }
  $onInit() {
    this.initialize();
    this.openBound = this.openCourseDetailModal.bind(this);
    this.closeBound = this.closeModal.bind(this);
    this.ngComponentCommunicatorService.subscribe('OPEN_COURSE_DETAIL_MODAL', this.openBound);
    this.ngComponentCommunicatorService.subscribe('CLOSE_COURSE_DETAIL_MODAL', this.closeBound);
  }
  $onChanges() {
    this.initialize();
  }

  getCourseCoReqStatus(courseCoRequisite: ICourseRequisite) {
    const coreqStatus = _4.get(
      _4.find(_4.get(this.ngScheduledSectionsQuery, 'result.list', []), { course: courseCoRequisite.course }),
      'status'
    );
    return coreqStatus;
  }

  onOpenChanged(e: any) {
    if (_4.get(e, 'currentTarget.$.dialogBody')) {
      e.currentTarget.$.dialogBody.scrollTo(0, 0);
    }
  }
  openCourseDetailModal() {
    this.isOpened = true;
  }

  closeModal() {
    this.isOpened = false;
    this.clearCrossCourseLinkedSectionsCommand();
  }
  addToTerm(courseId: number) {
    if (!this.ngCourseDetailsQuery.result) {
      return;
    }
    const slotId = _4.get(this.ngCourseDetailsQuery, 'result.course._planned_course.program_slot');
    this.saveCoReqCourseToTermCommand(this.ngCourseDetailsQuery.result.course.id, this.termId, slotId).then(() => {
      if (this.ngCourseDetailsQuery.result) {
        this.ngRegistrationAlertsServant.showAddedCoreqAlerts(this.ngCourseDetailsQuery.result.course);
      }
      this.getTermCoursesCommand(this.termId).then(() => {
        this.QueryMediator.runQueries(this.ngCourseDetailsModel);
      });
    });
  }
}

class CourseDetailComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.bindings = {
      courseId: '<',
      isOpened: '<'
    };
    this.controller = CourseDetail;
    this.templateUrl =
      'capability-ng-scheduler/src/views/course_details/components/course_details_component/course_detail_component.html';
  }
}
angular.module('capability-ng-scheduler').component('courseDetails', new CourseDetailComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_details/components/course_details_component/course_detail_component.ts